/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Vs_Win2_DInputs */

const en_wc_vs_win2_d = /** @type {(inputs: Wc_Vs_Win2_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MIT or Apache-2.0. Anyone can read the code, fix bugs, self-host the web build or ship it inside their own product.`)
};

/**
* | output |
* | --- |
* | "MIT or Apache-2.0. Anyone can read the code, fix bugs, self-host the web build or ship it inside their own product." |
*
* @param {Wc_Vs_Win2_DInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_vs_win2_d = /** @type {((inputs?: Wc_Vs_Win2_DInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Vs_Win2_DInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_vs_win2_d(inputs)
});
export { wc_vs_win2_d as "wc.vs.win2.d" }